import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PopularPlaceDetailRequestBody, PopularPlaceDetailResponse } from "./types";

export class PopularPlaceDetailAPI extends BaseAPI<
    PopularPlaceDetailRequestBody,
    PopularPlaceDetailResponse
> {
    protected route = ApiRoutes.popular_place.detail;
    protected method = RequestMethod.GET;
}
